import {observer} from 'mobx-react-lite'
import React from 'react'
import {DataObjectId} from 'yougile-model'
import {TriCheckboxNew} from '@components/common/base/checkbox-new'
import {useMultiActionsCheckbox} from '@components/multi-actions-with-tasks/use-multi-actions-checkbox'

export const MultiActionsCheckbox = observer(
  ({columnId}: {columnId: DataObjectId}) => {
    const {visible, value, onChange} = useMultiActionsCheckbox(columnId)
    return visible ? (
      <TriCheckboxNew className="mt-4" value={value} onChange={onChange} />
    ) : null
  }
)
